/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import PaymentMethod from '@linc-technologies/linced-common/enums/payment-method';
import ReceiptFormat from '@linc-technologies/linced-common/enums/receipt-format';

export default class ReceiptController extends Controller {
  // Services
  @service
  print;

  @service
  session;

  @service
  store;

  personId = '';
  Jurisdiction = Jurisdiction;
  PaymentMethod = PaymentMethod;

  @alias('session.school.jurisdiction')
  jurisdiction;

  @computed(
    'model.transactions.@each.{lineItem,amount}',
    'model.payment.amount',
  )
  get remainder() {
    let subtotal = this.get('model.transactions').reduce(
      (value, transaction) => {
        // Transfers to Line Items are negative, but Transfers to Accounts are positive.
        // Totalling their absolute values makes this irrelevant; they're all coming out of the source account.
        return value + Math.abs(transaction.amount);
      },
      0,
    );

    return this.get('model.payment.amount') - subtotal;
  }

  @computed('session.school.jurisdiction')
  get receiptFormat() {
    switch (this.get('session.school.jurisdiction')) {
      case Jurisdiction.AU_NSW:
        return ReceiptFormat.EIGHTYMM;
    }
    return ReceiptFormat.STANDARD;
  }

  @action
  receipt() {
    let person = this.model.person;
    if (isEmpty(person)) {
      person = this.get('model.payment.account.person');
    }

    let siblings = [];
    siblings.push(...person.get('learner.currentSiblings'));
    siblings.push(...person.get('learner.preEnrolledSiblings'));
    if (!isEmpty(siblings)) {
      let personIds = [person.get('id')];
      siblings.forEach((sibling) => {
        personIds.push(sibling.personId);
      });

      this.store
        .query('finance/account', { personIds: JSON.stringify(personIds) })
        .then((accounts) => {
          this.print.receipt(
            this.model.payment,
            accounts,
            this.get('session.school'),
            this.receiptFormat,
          );
        });
    } else {
      this.print.receipt(
        this.model.payment,
        null,
        this.get('session.school'),
        this.receiptFormat,
      );
    }
  }
}
